import { render, staticRenderFns } from "./BankingRalationships.vue?vue&type=template&id=06641a4d&"
import script from "./BankingRalationships.vue?vue&type=script&lang=js&"
export * from "./BankingRalationships.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports